import { ListItem, ListItemText } from '@mui/material'
import { ReportType } from '../../../generated/graphql'
import { SwitchInput } from '../../../inputs/switch-input'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { ReportForm } from '../report-form'

type Props = {
  reportType?: ReportType
}

export const ForceWarehouseFilter = ({ reportType }: Props) => {
  const { t } = useTranslation(['reports'])
  const { control } = useFormContext<ReportForm>()

  const showForceWarehouseFilter = [
    ReportType.Order,
    ReportType.Product,
    ReportType.Warehouse,
    ReportType.Stock,
  ].some((type) => type === reportType)

  if (!showForceWarehouseFilter) {
    return null
  }

  return (
    <ListItem
      component="label"
      secondaryAction={
        <SwitchInput name="forcewarehousefilter" control={control} />
      }
    >
      <ListItemText
        primary={t('manage_template_dialog.store_manager_warehouse_filtering')}
        secondary={t(
          'manage_template_dialog.store_manager_warehouse_filtering_description',
        )}
      />
    </ListItem>
  )
}
